<template>
    <v-dialog
      v-model="openDialog"
      fullscreen
      persistent
      transition="dialog-bottom-transition"
      :overlay="true"
      scrollable
      @keydown.esc="onCloseDialog"
    >
      <v-card class="white modalContent">
        <v-card-text>
          <v-container>
            <v-layout>
              <v-flex md8 offset-md2 xs12 id="modalColumn">
                <v-btn
                  icon
                  flat
                  text
                  @click.native="onCloseDialog"
                  class="text-xs-right m-0 p-0"
                  id="closeButton"
                >
                  <v-icon>close</v-icon>
                </v-btn>
                <slot></slot>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<style scoped lang="scss">
.modalContent {
  background: rgba(255, 255, 255, 0.95) !important;
  .v-card__text {
    margin-top: 40px; /* this is to account for the new impersonation header thingamabob. */
  }
}
#modalColumn{
  position:relative;
}
#closeButton {
  position:absolute;
  right: 0;
  margin: 0;
  padding: 0;
  top:-5px;
  ::v-deep .v-btn__content {
    margin: 0 0 0 40px;
  }
}
</style>

<script>
export default {
  props: ["showDialog", "returnRoute"],
  data() {
    return {};
  },
  computed: {
    openDialog: {
      get: function() {
        return this.showDialog;
      },
      set: function() {}
    }
  },
  methods: {
    onCloseDialog() {
      // 2022-09-29: This $router.go(-1) doesn't always work consistently
      // in practice. Sometimes the URL changes appropriately, but the
      // dialog does not unload and former component does not render.
      if (this.returnRoute) {
        this.$router.push(this.returnRoute);
      } else {
        this.$router.go(-1);
        console.warn('AmazeDialog:onCloseDialog - Defaulting to $router.go(-1) because the returnRoute property is empty. Please consider passing route parameters via the returnRoute property as this is a more reliable way to guarantee correct application navigation when a dialog is closed.');
      }
    }
  }
};
</script>
